import FlexPane from './_flex-pane.js'
import EventCardsCarousel from './_event-cards-carousel.js'
import PrebuiltPromotionCards from './_prebuilt-promotion-cards.js'
import MenuLinkPromotions from './_menu-link-promotions.js'
import BannerPromotions from './_banner-promotions.js'
import NextRacesController from './_next-races-controller.js'
import PageContextMenu from './_page-context-menu.js'
import TopSportsControllerView from './_top-sports-controller-view.js'

export default {
  name: 'HomePage',
  values: {
    primaryContentLayout: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '16px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    eventCardsCarousel: {
      configSet: EventCardsCarousel,
      configValues: {
        reportLoadingStatus: true,
      },
    },
    prebuiltPromotionCards: {
      configSet: PrebuiltPromotionCards,
      configValues: {
        reportLoadingStatus: true,
      },
    },
    secondaryContentContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    documentHeadMetaFactory: undefined,
    margin: 0,
    topPromotionsContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    topLinkPromotions: {
      configSet: MenuLinkPromotions,
      configValues: {
        reportLoadingStatus: true,
        menuRowSkeleton: {
          numberOfItems: 8,
          showIconPlaceholder: true,
          container: {
            itemSpacing: '16px',
            style: {
              padding: '13px 8px',
            },
          },
          linkPlaceholder: {
            style: {
              width: '56px',
              height: '13px',
            },
          },
        },
        menuRow: {
          style: {
            container: {
              height: '48px',
              padding: '4px 0',
              boxSizing: 'content-box',
            },
          },
          itemInnerContainer: {
            itemSpacing: '2px',
            style: {
              width: '72px',
              flexDirection: 'column',
            },
          },
          item: {
            unselected: {
              style: {
                base: {
                  flexGrow: 0,
                },
              },
            },
            selected: {
              style: {
                base: {
                  flexGrow: 0,
                },
              },
            },
          },
        },
      },
    },
    topBannerPromotions: {
      configSet: BannerPromotions,
      configValues: {
        reportLoadingStatus: true,
        view: {
          itemsLayout: 'horizontal',
          stacked: true,
          margin: '0',
          style: {
            container: {
              _mobile_padding: '4px 0px',
            },
          },
          bannerSkeletons: {
            bannerSkeletonContainer: {
              style: {
                width: '90%',
              },
            },
          },
        },
      },
    },
    leftPromotions: {
      configSet: BannerPromotions,
      configValues: {},
    },
    nextRacesSports: [
      {
        sportId: 'horse_racing',
        hide: true,
      },
      {
        sportId: 'greyhound_racing',
        hide: true,
      },
    ],
    nextRacesController: {
      configSet: NextRacesController,
      configValues: {},
    },
    hideTopContextMenu: true,
    _mobile_hideTopContextMenu: false,
    topContextMenu: {
      configSet: PageContextMenu,
      configValues: {
        _mobile_useRowLayout: true,
        rowLinkMenu: {
          reportLoadingStatus: true,
        },
      },
    },
    leftContextMenu: {
      configSet: PageContextMenu,
      configValues: {},
    },
    topSportsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '16px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    topSportCoupons: {
      optimizeRendering: true,
      primary: {
        hide: false,
        coupon: {
          configSet: TopSportsControllerView,
          configValues: {
            view: {
              displayEventListAsInplay: true,
            },
          },
        },
      },
      secondary: {
        hide: false,
        coupon: {
          configSet: TopSportsControllerView,
          configValues: {},
        },
      },
    },
    hideQuickStartGuideBanner: true,
  },
  meta: {
    extendable: false,
  },
}
